import { render, staticRenderFns } from "./purchase_returnGoods.vue?vue&type=template&id=c49cd2be&scoped=true&"
import script from "./purchase_returnGoods.vue?vue&type=script&lang=js&"
export * from "./purchase_returnGoods.vue?vue&type=script&lang=js&"
import style0 from "./purchase_returnGoods.vue?vue&type=style&index=0&id=c49cd2be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49cd2be",
  null
  
)

export default component.exports